import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== POMOCNICZE FUNKCJE ====

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomA1() {
  // a1 z przedziału -9..-2 ∪ 2..9 (bez -1, 0, 1)
  const candidates = [];
  for (let x = -9; x <= 9; x++) {
    if (Math.abs(x) >= 2 && Math.abs(x) <= 9) {
      candidates.push(x);
    }
  }
  const idx = Math.floor(Math.random() * candidates.length);
  return candidates[idx];
}

// ==== GENERATOR ====

export function generateTask() {
  const a1 = randomA1();

  // q całkowite 2..7, losowo dodatnie lub ujemne
  const baseQ = randomInt(2, 7);
  const sign = Math.random() < 0.5 ? 1 : -1;
  const q = sign * baseQ;

  // liczba wyrazów jak w zadaniu FindA1FromSumGeoTask: 3..6
  const n = randomInt(3, 6);

  const sum =
    q === 1
      ? a1 * n
      : (a1 * (1 - Math.pow(q, n))) / (1 - q);

  return {
    type: "FindQFromSumGeoTask",
    data: { sum, a1, n, q }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { sum, a1, n } = data;

  return (
    <>
      <p>
        Suma pierwszych <InlineMath math={`${n}`} /> wyrazów ciągu
        geometrycznego wynosi <InlineMath math={`${sum}`} />.
      </p>
      <p>
        Pierwszy wyraz ciągu to <InlineMath math={`a_1 = ${a1}`} />.
      </p>
      <p>
        Oblicz iloraz <InlineMath math="q" /> tego ciągu.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <div className="flex items-center gap-2">
      <InlineMath math={"q ="} />
      <FractionInput
        value={userAnswer}
        onChange={onChange}
        disabled={disabled}
        label="q"
      />
    </div>
  );
}

// ==== SPRAWDZANIE ====

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = userAnswer.parsed;
  if (given === null) return false;

  return Math.abs(given - data.q) < 0.01;
}

// ==== POPRAWNA ODPOWIEDŹ ====

export function renderAnswer({ data }) {
  return <InlineMath math={`q = ${data.q}`} />;
}

// ==== WYJAŚNIENIE ====

export function renderExplanation({ data }) {
  const { sum, a1, n, q } = data;

  const numerator = sum * (1 - q);
  const denominator = a1;
  const computedLeft = a1 * (1 - Math.pow(q, n));
  const computedRight = sum * (1 - q);

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Korzystamy ze wzoru na sumę{" "}
        <InlineMath math={`S_n`} /> ciągu geometrycznego dla{" "}
        <InlineMath math={"q \\neq 1"} />:
      </p>
      <BlockMath math={"S_n = a_1 \\cdot \\frac{1 - q^n}{1 - q}"} />

      <p>
        <strong>Krok 2:</strong> Podstawiamy dane.
      </p>
      <BlockMath
        math={`${sum} = ${a1} \\cdot \\frac{1 - q^{${n}}}{1 - q}`}
      />

      <p>
        Mnożymy obustronnie przez{" "}
        <InlineMath math={"1 - q"} />:
      </p>
      <BlockMath
        math={`${sum} \\cdot (1 - q) = ${a1}\\,(1 - q^{${n}})`}
      />

      <p>
        <strong>Krok 3:</strong> Szukamy takiej wartości{" "}
        <InlineMath math={"q"} />, dla której równanie jest spełnione.
        Wiemy, że w tym zadaniu{" "}
        <InlineMath math={"q"} /> jest liczbą całkowitą z przedziału{" "}
        <InlineMath math={"\\{ -7,-6,\\ldots,-2,2,3,\\ldots,7 \\}"} />.
      </p>

      <p>
        Sprawdźmy <InlineMath math={`q = ${q}`} />:
      </p>
      <BlockMath
        math={`${sum} \\cdot (1 - (${q})) = ${numerator}`}
      />
      <BlockMath
        math={`${a1}\\,(1 - (${q})^{${n}}) = ${computedLeft}`}
      />
      <p>
        Otrzymujemy po obu stronach tę samą wartość, więc{" "}
        <InlineMath math={`q = ${q}`} /> jest rozwiązaniem równania.
      </p>
    </div>
  );
}

// ==== ODP. UŻYTKOWNIKA W PODGLĄDZIE ====

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={`q = ${userAnswer.raw}`} />;
}
